// messaging.service.ts
import { Injectable } from "@angular/core";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { environment } from "../../environments/environment";
import { Subject } from "rxjs";
import { AngularFireMessaging } from "@angular/fire/compat/messaging";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class MessagingService {
  currentMessage = new Subject();

  constructor(
    private afMessaging: AngularFireMessaging,
    private toastr: ToastrService,
    private router: Router
  ) {
    const app = initializeApp(environment.firebase);

    this.requestPermissionAndGetToken(app);
    this.listen();
  }

  requestPermissionAndGetToken(app: any) {
    navigator.serviceWorker.ready
      .then((registration) => {
        const messaging = getMessaging(app);

        getToken(messaging, {
          vapidKey: environment.firebase.vapidKey,
          serviceWorkerRegistration: registration,
        })
          .then((currentToken) => {
            if (currentToken) {
              localStorage.setItem("fcm_token", currentToken);
            } else {
              localStorage.setItem("fcm_token", "");
              console.warn("No registration token available.");
            }
          })
          .catch((err) => {
            console.error("Error while retrieving FCM token:", err);
          });
      })
      .catch((err) => {
        console.error("Service worker not ready:", err);
      });
  }

  listen() {
    this.afMessaging.messages.subscribe((message: any) => {
      const title = message.notification?.title || "Notification";
      const body = message.notification?.body || "";

      const toast = this.toastr.info(body, title);

      toast.onTap.subscribe(() => {
        this.router.navigate(["main/admin/booking-list"]);
      });
    });
  }
}
